import { render, staticRenderFns } from "./gc-field-tag.vue?vue&type=template&id=bd4aadde"
import script from "./gc-field-tag.vue?vue&type=script&lang=js"
export * from "./gc-field-tag.vue?vue&type=script&lang=js"
import style0 from "./gc-field-tag.vue?vue&type=style&index=0&id=bd4aadde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports